import type { NodeVariant } from '@octopus-do/octopus-project-core'
import { TinyDropdownMenu, Toolbar } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { forwardRef } from 'react'

import { FRAME_MENU_ID, FRAME_OPTIONS } from './constants'

const Content: React.FC = () => (
  <TinyDropdownMenu.Grid columns={1}>
    {FRAME_OPTIONS.map(({ icon, id, tooltip }) => (
      <TinyDropdownMenu.IconOption
        icon={icon}
        id={id}
        key={id}
        tooltip={tooltip}
      />
    ))}
  </TinyDropdownMenu.Grid>
)

interface TriggerProps {
  locked: boolean
  onUpgrade: () => void
  variant: NodeVariant
}

// A locked frame keeps its button: the click sells the plan instead of opening the menu.
const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(
  ({ locked, onUpgrade, variant }, ref) => {
    const { active, toggle } = TinyDropdownMenu.useTrigger()

    const current =
      FRAME_OPTIONS.find(({ id }) => id === variant) ?? FRAME_OPTIONS[0]

    return (
      <Toolbar.DropdownButton
        active={active}
        icon={current.icon}
        locked={locked}
        onClick={locked ? onUpgrade : toggle}
        ref={ref}
        tooltip="Frame"
      />
    )
  }
)

interface Props {
  locked: boolean
  onUpgrade: () => void
  variant: NodeVariant
}

export const FrameMenu: React.FC<Props> = ({ locked, onUpgrade, variant }) => {
  const { onClick } = Toolbar.useToolbarClick(FRAME_MENU_ID)

  return (
    <TinyDropdownMenu.Root
      active={[variant]}
      content={Content}
      onClick={onClick}
      width="fit"
    >
      <Trigger locked={locked} onUpgrade={onUpgrade} variant={variant} />
    </TinyDropdownMenu.Root>
  )
}
